import { get, post, postv3, getv3 } from "@/utils/common.js";

const APP_baseUrl = process.env.VUE_APP_APPAPI
//1表示有，0表示无
// const ShopList = (data) => get(`${APP_baseUrl}api/Enterprise/GetEnterpriseList`, data); //店铺列表1
// const EditSwichEnterprise = (data) => post(`${APP_baseUrl}api/EnterpriseUser/EditSwichEnterprise`, data); //店铺切换0
// const GetInquiryList = params => post(`LianOuService/GetShopInquiryList`, params); //问诊列表信息已完成0
// const GetShopInqDbList = params => post(`LianOuService/GetShopInqDbList`, params); //问诊列表信息未完成0
// const GetDrugsList = (params, tipText) => post(`LianOuService/GetDrugsList`, params, "搜索中"); //搜索药品0
// const GetDiseaseList = (params) => post(`LianOuService/GetDiseaseList`, params, "搜索中"); //搜索疾病1
// const GetOrder = (params) => post(`LianOuService/GetOrder`, params); //获取处方信息0
// const SaveInquiry = (params) => post(`LianOuService/SaveInquiry`, params); //新增问诊信息（包括续方）1
// const GetInquiry = (data) => post(`LianOuService/GetInquiry`, data); //问诊信息回显（包括续方）1
const UpdateInquiry = (data) => post(`LianOuService/UpdateInquiry`, data); //修改问诊信息1
// const GetInquiryHistoryList = (data) => post(`LianOuService/GetInquiryHistoryList`, data); //历史处方列表0
// const GetShopList = (data) => post(`LianOuService/GetShopList`, data); //门店列表0
// const GetShopExcelList = (data) => post(`LianOuService/GetShopExcelList`, data); //门店导出列表0
const DownLoadToBase64 = (data) => post(`LianOuService/DownLoadToBase64`, data); //下载图片

const GetPharName = (data) => post(`LianOuService/GetPharName`, data); //获取药师签名记录0
const SignPharmacistName = (data) => post(`LianOuService/SignPharmacistName`, data); //药师签名到处方上0
const GetQRCodePharName = (data) => post(`LianOuService/GetQRCodePharName`, data); //药师签名到处方上0
// const GetQrCode = (data) => get(`${APP_baseUrl}api/XyjLogin/GetQrCode`, data); //获取登录二维码
// const GetQrCodeLoginStatus = (data) => post(`${APP_baseUrl}api/XyjLogin/GetQrCodeLoginStatus`, data); //获取登录二维码状态





// const GetDoctorList = (data) => post('LianOuService/SearchDoctor', data); //医生列表 GetDoctorList 1
// const SendVaildCode = (data) => post('LianOuService/SendVaildCode', data); //-发送短信验证码
// const VerificationLogin = (data) => post('LianOuService/VerificationLogin', data); //-发送短信验证码0

// const GetUserSig = (data) => post('TxIm/GetUserSig', data); //-获取UserSig0 

const GetPrescriptionInfo = (data) => post('TxIm/GetPrescriptionInfo', data); //-获取处方信息（聊天）0

const GetGroupMsg = (data) => post('/TxIm/GetGroupMsg', data); //历史聊天记录0
// const GetOrderData = (data) => post('LianOuService/GetOrderData', data); //获取处方单打印0

//v3接口调整接口
const submitLoading = "提交中...";
const searchLoading = "加载中...";
const swartingLoading = "请稍等...";
const GetQrCode = (data) => getv3('Account/GetQrCode', data); //获取二维码
const GetQrCodeLoginStatus = (data) => getv3('Account/GetQrCodeLoginStatus', data); //获取登录二维码状态
const SendVaildCode = (data) => getv3('Account/SendVaildCode', data, swartingLoading); //-发送短信验证码
const ShopList = (data) => getv3(`Shop/GetShopList`, data); //获取我所有关联的店铺信息 由GetEnterpriseList更换为
const EditSwichEnterprise = (data) => getv3(`Shop/ChangeShop`, data); //店铺切换0
const GetDoctorList = (data) => getv3('Shop/SearchDoctor', data); //医生列表
const GetDrugsList = (params) => getv3(`Inquiry/GetDrugList`, params); //搜索药品
const GetDiseaseList = (params) => getv3(`Inquiry/GetDiseaseList`, params); //搜索疾病
const GetInquiryList = (data) => postv3(`Inquiry/GetPCInquiryList`, data); //问诊列表
const GetInquiryHistoryList = (data) => postv3(`Inquiry/GetPCOrderList`, data); //历史处方列表
const GetDiagnoseByComNames = (data) => getv3(`Inquiry/GetDiagnoseByComNames`, data); //根据药品获取常用疾病
const GetInquiry = (data) => getv3(`Inquiry/GetInquiry`, data); //问诊详情
const GetInquiryPicCode = (data) => getv3(`Inquiry/GetInquiryPicCode`, data); //图片路径换
const GetPrescribe = (data) => getv3(`Inquiry/GetPrescribe`, data, swartingLoading); //查看处方内容
const SavePatient = (params) => postv3(`Inquiry/SavePatient`, params); //新增个人信息（包括续方)
const SaveInquiry = (params) => postv3(`Inquiry/SaveInquiry`, params); //新增问诊信息（包括续方)
const CheckPharSignImg = (params) => getv3(`Inquiry/CheckPharSignImg`, params, swartingLoading); //检测是否有药师签名
const AuditPrescribe = (params) => getv3(`Inquiry/AuditPrescribe`, params, swartingLoading); //药师审核处方
const GetChildShopList = (params) => getv3(`Shop/GetChildShopList`, params); //获取当前店铺的id和用户名
const GetExcelShopList = (params) => getv3(`Shop/GetExcelShopList`, params); //获取店铺问诊数量统计
const GetPicCodeByUrl = (params) => getv3(`Shop/GetPicCodeByUrl`, params, searchLoading); //获取店铺问诊数量统计GET 
const GetPackage = (params) => getv3(`Shop/GetPackage`, params); //获取套餐信息接口
const GetUserSig = (data) => postv3('LoIm/GetUserSig', data); //-获取UserSig0 
const CheckPhar = (data) => getv3('Inquiry/CheckPhar', data, searchLoading); //-获取UserSig0 
const GetPCOrderData = (data) => getv3('Inquiry/GetPCOrderData', data, searchLoading); //-获取UserSig0 
const DownLoadOrderList = (data) => postv3('Inquiry/DownLoadOrderList', data, searchLoading); //批量导出
const GetInquiryEncodeData = (data) => getv3('Inquiry/GetInquiryEncodeData', data, searchLoading); //-获取明码
const GetInquiryWxOpenQrCode_Base64 = (data) => getv3('Inquiry/GetInquiryWxOpenQrCode_Base64', data, searchLoading); //-获取微信提交二维码


const CreateDownLoadOrderList = (data) => postv3('Inquiry/CreateDownLoadOrderList', data, searchLoading); //批量导出

const GetShopPackage = (data) => postv3('Inquiry/GetShopPackage', data, searchLoading); //店铺处方包套餐
const GetShopPackageDrug = (data) => postv3('Inquiry/GetShopPackageDrug', data); //套餐药品
const GetWxOpenChooseDrugsQRCode_Base64 = (data) => getv3('Inquiry/GetWxOpenChooseDrugsQRCode_Base64', data); //店铺问诊二维码
const GetWxOpenChooseDrugsQRCode_Base64New = (data) => getv3('Inquiry/GetWxOpenChooseDrugsQRCode_Base64New', data); //店铺问诊二维码

const ExportExcelShopList = (data) => getv3('Shop/ExportExcelShopList', data); //导出 获取店铺问诊数量统计
const GetValidationCode = (data) => getv3('Account/GetValidationCode', data); //获取验证码
const DoctorPcLogin = (data) => postv3('Account/DoctorPcLogin', data); //-发送短信验证码0
const PushToOpenPrescriptionSys = (data) => postv3('Inquiry/PushToOpenPrescriptionSys', data); //-点击“远程审方”按钮，推送处方到第三方远程审方系统

const CreateDownLoadInq = (data) => postv3('Inquiry/CreateDownLoadInq', data); //导出




window.GetUserSig = GetUserSig
export {
    GetGroupMsg,
    GetPrescriptionInfo,
    GetUserSig,
    GetDoctorList,
    SendVaildCode,
    DoctorPcLogin,
    GetInquiryList,
    GetDrugsList,
    SavePatient,
    SaveInquiry,
    GetInquiry,
    ShopList,
    APP_baseUrl,
    GetDiseaseList,
    EditSwichEnterprise,
    UpdateInquiry,
    GetInquiryHistoryList,
    GetPharName,
    SignPharmacistName,
    GetQRCodePharName,
    GetQrCode,
    GetQrCodeLoginStatus,
    DownLoadToBase64,
    GetPCOrderData,
    GetDiagnoseByComNames,
    GetInquiryPicCode,
    GetPrescribe,
    CheckPharSignImg,
    AuditPrescribe,
    GetChildShopList,
    GetExcelShopList,
    GetPicCodeByUrl,
    GetPackage,
    CheckPhar,
    DownLoadOrderList,
    CreateDownLoadOrderList,
    GetShopPackage,
    GetShopPackageDrug,
    GetWxOpenChooseDrugsQRCode_Base64,
    GetWxOpenChooseDrugsQRCode_Base64New,
    GetInquiryEncodeData,
    GetInquiryWxOpenQrCode_Base64,
    ExportExcelShopList,
    GetValidationCode,
    PushToOpenPrescriptionSys,
    CreateDownLoadInq
}